import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { IAppState } from '../app.state';
import { of } from 'rxjs';

import { PublicService } from '../../@core/data/public/public.service';
import { TaricCodesError, TaricCodesLoaded, TaricCodesRequested } from './taricCodes.actions';
import { ITaricCodesState } from './taricCodes.state';


@Injectable()
export class TaricCodesEffects {
  constructor(private actions$: Actions, private store: Store<IAppState>, private publicService: PublicService) {}

  requestTaricCodes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TaricCodesRequested),
      mergeMap(() =>
        this.publicService.getTaric().pipe(
          map((res: any) =>
            res
              ? TaricCodesLoaded({
                  tarics: res.map((taric) => ({ ...taric, selected: false })),
                  taricTree: []
                })
              : TaricCodesLoaded({ tarics: [], taricTree: [] })
          ),
          catchError((error: any) => of(TaricCodesError()))
        )
      )
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TaricCodesError),
        tap(() => {})
      ),
    { dispatch: false }
  );
}
